import { FC, memo, useContext } from 'react';

import { BankStatementsBrokerModal as SharedBankStatementsBrokerModal } from '~/core/shared/components/BankStatementsBrokerModal';
import { ApplicationContext } from '../../Layout.component';
import { useBankStatementsBrokerModalApi } from './hooks';

const BankStatementsBrokerModalComponent: FC = () => {
  const modalApi = useBankStatementsBrokerModalApi();
  const { applicationUuid, definition, setLastApplicationUpdate } =
    useContext(ApplicationContext);

  return (
    <SharedBankStatementsBrokerModal
      definition={definition}
      modalApi={modalApi}
      onSuccess={() => setLastApplicationUpdate(new Date())}
      uuid={applicationUuid}
      withSync
    />
  );
};

export const BankStatementsBrokerModal = memo(
  BankStatementsBrokerModalComponent,
);
